import { useTranslation } from 'react-i18next';
import { MapPin } from 'lucide-react';

interface ShopSelectionGateProps {
  requireSingleShop?: boolean;
}

export function ShopSelectionGate({ requireSingleShop = false }: ShopSelectionGateProps) {
  const { t } = useTranslation();

  return (
    <div className="card text-center py-10 text-gray-500 border border-dashed border-gray-200">
      <MapPin className="w-8 h-8 mx-auto mb-3 text-primary-500" aria-hidden />
      <p className="font-medium text-textPrimary">
        {requireSingleShop
          ? t('planning.calendar.selectSingleShop', 'Sélectionnez un shop précis')
          : t('planning.calendar.selectShop', 'Sélectionnez un shop')}
      </p>
      <p className="text-sm mt-1 max-w-md mx-auto">
        {requireSingleShop
          ? t(
              'planning.calendar.selectSingleShopHint',
              'Choisissez un shop spécifique dans l’en-tête pour créer ou modifier des données.',
            )
          : t(
              'planning.calendar.selectShopHint',
              'Choisissez le shop courant dans l’en-tête pour afficher les données de ce shop.',
            )}
      </p>
    </div>
  );
}
